import { Box as MuiBox } from '@mui/material'

export function Box({ ...props }) {
  return <MuiBox {...props} />
}
